import React, { useState } from "react";
import {
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Checkbox,
  Stack,
  Flex,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  FormControl,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  useColorModeValue,
} from "@chakra-ui/react";
import { BiSliderAlt } from "react-icons/bi";
import useGeneral from "hooks/use-general";
import Select from "react-select";
import useReceivingSector from "hooks/use-receiving";
import LoadingComponent from "components/Main/Loading";
import FornecedorTable from "./FornecedorTable";

interface Props {
  isOpen: boolean;
  onClose?: () => void;
}

const ModalUpdateReceivingStore: React.FC<Props> = ({ isOpen, onClose }) => {
  const textColor = useColorModeValue("black", "white");
  const [indexTab, setIndexTab] = useState(0);
  const { data: dataStore } = useGeneral();
  const {
    handleDynamic,
    handleStore,
    setEditIdx,
    params,
    setEditEntry,
    setNewEntry,
    paramsData,
    loadingUpdate,
    returnDataOriginal,
    loadingEdit,
    putData,
    limits, // 👈
    handleUpdateLimit, // 👈
  } = useReceivingSector();
  var gerentes = paramsData
    .filter((x: any) => x.receivingSectorId === 2)
    .map((x: any) => x.productManagerDescription);

  const handleSubmit = () => {
    putData(params);
    // onClose();
  };
  const parseValueSelect = (id: number) => {
    const valueOption = dataStore.find((item) => item.value === id);
    return valueOption;
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size={indexTab === 0 ? "7xl" : "7xl"}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader
          paddingTop={2}
          paddingBottom={2}
          paddingLeft={4}
          paddingRight={4}
          textColor={"gray.200"}
          background={"#1d5840"}
          borderTopLeftRadius={5}
          borderTopRightRadius={5}
          borderBottom="3px solid #ECC94B"
        >
          <Flex>
            <Box p={2}>
              <BiSliderAlt />
            </Box>
            <Box p={2} pt={1} w={1200}>
              Atualizar
            </Box>
          </Flex>
        </ModalHeader>
        <ModalCloseButton color="white" />
        <ModalBody>
          {loadingEdit ? (
            <>
              <LoadingComponent spinnerSize="40vh" />
            </>
          ) : (
            <>
              <Tabs>
                <TabList>
                  <Tab
                    onClick={() => {
                      setIndexTab(0);
                      setEditEntry(null);
                      setEditIdx(null);
                      setNewEntry(null);
                    }}
                  >
                    GP
                  </Tab>
                  <Tab
                    onClick={() => {
                      setIndexTab(1);
                      setEditEntry(null);
                      setEditIdx(null);
                      returnDataOriginal();
                      setNewEntry(null);
                    }}
                  >
                    Fornecedor
                  </Tab>
                </TabList>

                <TabPanels>
                  <TabPanel>
                    <Box
                      maxW={480}
                      flex={{ base: "1", md: "0 0 300px" }}
                      pb={6}
                    >
                      <Select
                        onChange={handleStore}
                        defaultValue={parseValueSelect(
                          paramsData[0] !== null && paramsData[0] !== undefined
                            ? paramsData[0].storeId
                            : 0
                        )}
                        name="colors"
                        isDisabled={true}
                        options={dataStore}
                        styles={{
                          control: (provided: any) => ({
                            ...provided,
                            backgroundColor: "white",
                            borderColor: "black",
                          }),
                        }}
                        className="custom-select"
                        classNamePrefix="select"
                      />
                    </Box>
                    <Box overflowX="auto">
                      <Table size="sm">
                        <Thead>
                          <Tr>
                            <Th></Th>
                            <Th
                              border="1px solid black"
                              colSpan={
                                paramsData.filter(
                                  (x) => x.receivingSectorId === 1
                                ).length + 1
                              }
                              textAlign="center"
                              fontWeight="bold"
                            >
                              Ferragens
                            </Th>
                            <Th
                              border="1px solid black"
                              colSpan={
                                paramsData.filter(
                                  (x) => x.receivingSectorId === 2
                                ).length + 1
                              }
                              textAlign="center"
                              fontWeight="bold"
                            >
                              Chaparia
                            </Th>
                          </Tr>
                          <Tr>
                            <Th></Th>
                            <Th border="1px solid black" fontWeight="bold">
                              Limite Diario
                            </Th>
                            {paramsData
                              .filter((x) => x.receivingSectorId === 1)
                              .map((x) => (
                                <Th
                                  key={`f-head-${x.id}`}
                                  border="1px solid black"
                                >
                                  {x.productManagerDescription}
                                </Th>
                              ))}
                            <Th border="1px solid black" fontWeight="bold">
                              Limite Diario
                            </Th>
                            {paramsData
                              .filter((x) => x.receivingSectorId === 2)
                              .map((x) => (
                                <Th
                                  key={`c-head-${x.id}`}
                                  border="1px solid black"
                                >
                                  {x.productManagerDescription}
                                </Th>
                              ))}
                          </Tr>
                        </Thead>

                        <Tbody>
                          {(
                            [
                              "segunda",
                              "terca",
                              "quarta",
                              "quinta",
                              "sexta",
                            ] as const
                          ).map((day) => (
                            <Tr key={day}>
                              <Td scope="row" textTransform="capitalize">
                                {day[0].toUpperCase() + day.slice(1)}
                              </Td>

                              {/* LIMIT FERRAGENS */}
                              <Td border="1px solid black" fontWeight="bold">
                                <FormControl>
                                  <NumberInput
                                    width="100px"
                                    background="yellow.100"
                                    min={0}
                                    max={10000}
                                    value={
                                      limits.find(
                                        (l) => l.receivingSectorId === 1
                                      )?.[day] ?? 0
                                    }
                                    onChange={(value) =>
                                      handleUpdateLimit(1, day, Number(value))
                                    }
                                  >
                                    <NumberInputField color={textColor} />
                                  </NumberInput>
                                </FormControl>
                              </Td>

                              {/* FERRAGENS */}
                              {paramsData
                                .filter((x) => x.receivingSectorId === 1)
                                .map((x) => (
                                  <Td
                                    border="1px solid black"
                                    key={`f-${x.id}-${day}`}
                                  >
                                    <FormControl>
                                      <NumberInput
                                        width="100px"
                                        min={0}
                                        max={10000}
                                        value={x[day]}
                                        onChange={(value) =>
                                          handleDynamic(x.id, day, value)
                                        }
                                      >
                                        <NumberInputField color={textColor} />
                                      </NumberInput>
                                    </FormControl>
                                  </Td>
                                ))}

                              {/* LIMIT CHAPARIA */}
                              <Td border="1px solid black" fontWeight="bold">
                                <FormControl>
                                  <NumberInput
                                    width="100px"
                                    min={0}
                                    background="yellow.100"
                                    max={10000}
                                    value={
                                      limits.find(
                                        (l) => l.receivingSectorId === 2
                                      )?.[day] ?? 0
                                    }
                                    onChange={(value) =>
                                      handleUpdateLimit(2, day, Number(value))
                                    }
                                  >
                                    <NumberInputField color={textColor} />
                                  </NumberInput>
                                </FormControl>
                              </Td>

                              {/* CHAPARIA */}
                              {paramsData
                                .filter((x) => x.receivingSectorId === 2)
                                .map((x) => (
                                  <Td
                                    border="1px solid black"
                                    key={`c-${x.id}-${day}`}
                                  >
                                    <FormControl>
                                      <NumberInput
                                        width="100px"
                                        min={0}
                                        max={10000}
                                        value={x[day]}
                                        onChange={(value) =>
                                          handleDynamic(x.id, day, value)
                                        }
                                      >
                                        <NumberInputField color={textColor} />
                                      </NumberInput>
                                    </FormControl>
                                  </Td>
                                ))}
                            </Tr>
                          ))}
                        </Tbody>
                      </Table>
                    </Box>
                  </TabPanel>
                  <TabPanel>
                    <FornecedorTable />
                  </TabPanel>
                </TabPanels>
              </Tabs>
            </>
          )}
        </ModalBody>

        <ModalFooter>
          {indexTab === 0 && (
            <>
              <Button variant="ghost" onClick={onClose}>
                Fechar
              </Button>
              <Button
                colorScheme="green"
                ml={3}
                onClick={handleSubmit}
                disabled={loadingUpdate}
              >
                Salvar
              </Button>
            </>
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ModalUpdateReceivingStore;
